'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var baseX = require('./baseX.cjs');

/**
 * A string serializer that uses base58 encoding.
 * @category Serializers
 */
const base58 = baseX.baseX('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');

exports.base58 = base58;
//# sourceMappingURL=base58.cjs.map
